import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ProgressBar from "../../components/OrderProgressBar/ProgressBar";
import MyOrderProductCard from "../../components/Orders/MyOrderProductCard";
import { BASE_URL, USER_URL } from "../../constant/api";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { FaLocationDot } from "react-icons/fa6";
import { toast } from "react-toastify";

function OrderDetails() {
  const { order_number, id } = useParams();
  const [orderDetails, setOrderDetails] = useState(null);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrderDetails = async () => {
    try {
      // const token = localStorage.getItem("token");
      // const headers = { Authorization: `JWT ${token}` };
      const response = await USER_URL.get(`/orders/${order_number}/${id}/`);
      setOrderDetails(response.data.Data[0]);
      console.log("Order Details:", response.data);
      // Assuming response data is an array, selecting first item.
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setLoading(false);
    }
  };

  const cancelOrder = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `JWT ${token}` };
      const response = await axios.get(
        `${BASE_URL}/orders/${order_number}/${id}/cancel/`,
        { headers },
      );
      console.log("Cancel Order Response:", response.data);

      if (response.data.Status=== "1") {
        // alert("Order canceled successfully!");
        // Optionally, update the state to reflect the cancellation
        setOrderDetails((prevState) => ({
          ...prevState,
          order_state: "Cancelled", // Change the status to Cancelled
        }));
      } else {
        // toast.error("Failed to cancel the order.");
        console.log("Failed to cancel the order:", response.data.Message);
        
      }
    } catch (error) {
      console.error("Error canceling the order:", error.response.data);
      alert("There was an error canceling the order.");
    }
  };

  const fetchTrendingProducts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/products/trending/`);
      setTrendingProducts(response.data.Data || []);
    } catch (error) {
      console.error("Error fetching trending products:", error);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
    fetchTrendingProducts();
  }, [order_number, id]);

  if (loading) return <div>Loading...</div>;

  if (!orderDetails) return <div>Order details not available.</div>;

  const productImage = orderDetails.product_images?.[0]?.image
    ? orderDetails.product_images[0].image.startsWith(BASE_URL)
      ? orderDetails.product_images[0].image
      : `${BASE_URL}${orderDetails.product_images[0].image}`
    : "/images/default-product.png";

  const formattedAddress = `${orderDetails.address?.[0]?.name || "N/A"} <br />
  ${orderDetails.address?.[0]?.house_name || "N/A"} <br />
  ${orderDetails.address?.[0]?.city || "N/A"}, 
  ${orderDetails.address?.[0]?.state || "N/A"} <br />
  ${orderDetails.address?.[0]?.pincode || "N/A"} <br />
  ${orderDetails.address?.[0]?.mobile_number || "N/A"}`;

  return (
    <div className="container mx-auto mb-10 border-t-2 p-4 md:p-6">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* Order Details Card */}
        <div className="lg:col-span-2">
          <h1 className="mb-6 mt-2 text-xl font-bold md:text-2xl">
            Order Details
          </h1>
          <ProgressBar orderStatus={orderDetails.order_status} />
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            {/* Order Details Card */}
            <div className="mt-10 h-auto rounded-lg border-2 bg-white p-4 shadow-md md:mt-20 md:p-6">
              {/* Order Header */}
              <div className="mb-4 flex flex-wrap items-center justify-between border-b-2 pb-2">
                <h2 className="text-custom-color w-full text-xs font-bold md:w-auto">
                  Order Id:{" "}
                  <span className="font-semibold text-gray-500">
                    {orderDetails.order_number || "N/A"}
                  </span>
                </h2>

                <span className="w-full text-right text-xs font-semibold md:w-auto">
                  Sub Total : {orderDetails.currency_symbol} {orderDetails.subtotal?.toFixed(2) || "0.00"}
                </span>
              </div>

              {/* Product Details */}
              <div className="mb-4 flex flex-wrap items-start border-b-2 pb-2">
                <img
                  src={productImage}
                  alt={orderDetails.name || "Product"}
                  className="mb-4 h-20 w-20 rounded-md object-cover md:mb-0 md:h-24 md:w-24"
                />
                <div className="ml-4 flex-1">
                  <h3 className="text-lg font-bold text-black">
                    {orderDetails.name || "Product Name"}
                  </h3>
                  <p className="mb-2 line-clamp-2 text-sm text-gray-500">
                    {orderDetails.description || "No Description"}
                  </p>
                  <p className="text-sm text-gray-500">
                    Quantity - {orderDetails.quantity || 0}
                  </p>
                  <p className="text-2xl font-bold font-sans text-black">
                    {" "}
                    {orderDetails.currency_symbol} {orderDetails.price?.toFixed(2) || "0.00"}
                  </p>
                </div>
              </div>

              {/* Expected Delivery */}
              <p className="mb-4 mt-2 border-b-2 pb-3 text-sm">
                <strong>Expected Delivery :</strong>{" "}
                {orderDetails.delivery_date || "N/A"}
              </p>

              {/* Address */}
              <div className="flex items-start border-b-2 pb-2">
                <FaLocationDot className="mr-2 text-xl" />{" "}
                {/* Left side logo */}
                <div className="text-sm text-gray-500">
                  <div>{orderDetails.address?.[0]?.name || "N/A"}</div>
                  <div>{orderDetails.address?.[0]?.house_name || "N/A"}</div>
                  <div>
                    {orderDetails.address?.[0]?.city || "N/A"},{" "}
                    {orderDetails.address?.[0]?.state || "N/A"}
                  </div>
                  <div>{orderDetails.address?.[0]?.pincode || "N/A"}</div>
                  <div>{orderDetails.address?.[0]?.mobile_number || "N/A"}</div>
                </div>
              </div>

              {/* Payment Mode */}
              <p className="mb-4 mt-2 border-b-2 pb-2 text-sm">
                <strong>Mode of Payment :</strong>{" "}
                {orderDetails.payment_type || "N/A"}
              </p>

              {/* Action Buttons */}
              <div className="flex flex-wrap justify-between gap-4">
                {/* Contact Us Button */}
                <button className="flex w-full items-center gap-2 rounded-md border border-blue-500 px-4 py-2 text-sm text-blue-500 sm:w-[150px] md:text-base">
                  <TfiHeadphoneAlt />
                  Contact Us
                </button>

                {/* Cancel Button */}
                {orderDetails.order_state === "Cancelled" ? (
                  <button
                    className="w-full rounded-md bg-red-500 px-4 py-2 text-sm text-white sm:w-[150px] md:text-base"
                    disabled
                  >
                    Cancelled
                  </button>
                ) : (
                  <button
                    className="w-full rounded-md bg-green-500 px-4 py-2 text-sm text-white sm:w-[150px] md:text-base"
                    onClick={cancelOrder}
                  >
                    Cancel Order
                  </button>
                )}
              </div>
            </div>

            {/* Price Details Card */}
            <div className="mt-20 h-[250px] rounded-lg border-2 bg-white p-4 shadow-md md:p-6">
              <h2 className="mb-4 border-b pb-2 text-lg font-bold">
                Price Details
              </h2>
              <div className="space-y-1 text-gray-600">
                <div className="flex justify-between text-sm">
                  <span>Original Price</span>
                  <span> {orderDetails.currency_symbol}{orderDetails.subtotal || 0}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>Quantity</span>
                  <span>{orderDetails.quantity || 0}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>Delivery Charge</span>
                  <span> {orderDetails.currency_symbol}{orderDetails.delivery_charge || "Free"}</span>
                </div>
              </div>
              <div className="mt-4 flex justify-between border-t pt-2 text-lg font-bold">
                <span>SUB TOTAL</span>
                <span className="font-sans"> {orderDetails.currency_symbol} {orderDetails.subtotal || 0}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Trending Products Section */}
        <div className="mt-0 grid grid-cols-1">
          <MyOrderProductCard
            products={trendingProducts}
            title="Trending Products"
            layout="vertical-3-horizontal-2"
          />
        </div>
      </div>
    </div>
  );
}

export default OrderDetails;
